import { Box, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import InputMascarado from "../../input-mascarado/InputMascarado";
import Input from "../../input/input";
import {
  mascaraCep,
  mascaraCnpj,
  mascaraCpf,
  mascaraTelefone,
} from "../../../../utils/mascaras";
import { PixKeyTypeEnum } from "../../../../../pages/enum";
import { BuscarBancos } from "../../../buscarBancos/buscar-bancos";
import { SelectAccountBankType } from "../../select/SelectAccountBankType";
import { SelectPixKeyType } from "../../select/SelectPixKeyType";

interface ContaBancariaFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
}

export function ContaBancariaFormPart({
  methods,
  mdDown,
  disabled = false,
}: ContaBancariaFormProps) {
  const pixKeyType = methods.watch("accountBank.pixKeyType");

  function getPixMask(type: string) {
    switch (type) {
      case PixKeyTypeEnum.CPF:
        return mascaraCpf;
      case PixKeyTypeEnum.CNPJ:
        return mascaraCnpj;
      case PixKeyTypeEnum.PHONE:
        return mascaraTelefone;
      default:
        return (v: string) => v;
    }
  }

  return (
    <Box>
      <Typography variant="h5" padding="20px 0">
        Dados Bancários:
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns={mdDown ? "1fr" : "1fr 1fr 1fr"}
        gap="20px"
        width="100%"
        flexWrap="wrap"
      >
        <BuscarBancos label="Banco" methods={methods} name="accountBank.bank" />
        <Input
          name="accountBank.agency"
          label="Agência"
          methods={methods}
          disabled={disabled}
        />

        <Input
          name="accountBank.account"
          label="Conta"
          methods={methods}
          disabled={disabled}
        />

        <SelectAccountBankType name="accountBank.accountType" methods={methods} disabled={disabled} />

        <SelectPixKeyType name="accountBank.pixKeyType" methods={methods} disabled={disabled} />

        <InputMascarado
          name="accountBank.pixKey"
          methods={methods}
          label="Chave Pix"
          mask={getPixMask(pixKeyType)}
        />
      </Box>
    </Box>
  );
}
